import { render, staticRenderFns } from "./recuperarContrasena.vue?vue&type=template&id=1c166b1a&scoped=true&"
import script from "./recuperarContrasena.vue?vue&type=script&lang=js&"
export * from "./recuperarContrasena.vue?vue&type=script&lang=js&"
import style0 from "./recuperarContrasena.vue?vue&type=style&index=0&id=1c166b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c166b1a",
  null
  
)

export default component.exports